import Behaviour, { mix } from '@/core'
import { Route } from '@/core/router'
import SponLax from 'sponlax'

export default class ScrollReveal extends mix(Behaviour).with(Route) {
	constructor(el) {
		super(el)

		this.withRoutes()

		this.animateHero(true)
	}

	mounted = () => {
		this.selector = '[data-motion="splash"]'

		this.options = {
			// rootMargin: '-25%',
			shouldUnObserve: () => true,
			onEnter: $node => {
				$node.classList.add('is-inview')
			},
			onLeave: $node => {
				$node.classList.remove('is-inview')
			}
		}

		this.lax = new SponLax(this.selector, this.options)
	}

	onChange = () => {
		this.lax && this.lax.disconnect()

		this.animateHero()
	}

	onComplete = () => {
		this.lax && this.lax.update(this.selector, this.options)

		this.animateHero(true)
	}

	animateHero = (animateIn = false) => {
		const $hero = document.querySelector('.hero__text-container')
		if (!$hero) return false

		if (animateIn) {
			$hero.classList.add('animate-in')
		} else {
			$hero.classList.remove('animate-in')
		}
	}
}
